



























































import { Component, Vue} from 'vue-property-decorator'; // デコレータ
import { orderUsersModule } from '../store/modules/OrderUsers'; // ストアモジュール
@Component
export default class UserMenu extends Vue {
  private created() {
    orderUsersModule.moduleReset();
  }
}
